<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Change Password
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          label="Current Password"
          outlined
          type="password"
          v-model="prevPassword"
          v-on:keyup.enter="onEnter"
        >
        </v-text-field>
        <v-text-field
          label="New Password"
          outlined
          type="password"
          v-model="newPassword"
          v-on:keyup.enter="onEnter"
        >
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn v-if="canCancel" color="blue" text @click="onCancelClick()">Cancel</v-btn>
        <v-btn color="blue" text :disabled="submitDisabled" @click="onChangePasswordClick()">Change Password</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    canCancel: Boolean,
  },

  data() {
    return {
      prevPassword: '',
      newPassword: '',
    };
  },

    computed: {
      submitDisabled() {
        return this.prevPassword.length === 0 || this.newPassword.length < 12 || this.prevPassword === this.newPassword;
      },
    },

  methods: {
    onChangePasswordClick() {
      // this.$emit(':', { prevPassword: this.prevText, newPassword: this.newPassword });
      // this.prevPassword = '';
      // this.newPassword = '';

      const options = {
        method: 'post',
        url: '/update/user_password/v1',
        data: {
          username: this.$store.state.auth.token.user.username,
          prevPassword: this.prevPassword,
          newPassword: this.newPassword,
        },
      };

      this.axios(options)
        .then((res) => {
          if (res.status === 200) {
            console.log('password was changed successfully');

            this.$emit('close');

            this.prevPassword = '';
            this.newPassword = '';
          } else {
            console.log(`failed to change password: ${res.status}`);
          }
        })
        .catch((err) => {
          console.log('error changing password');
        });
    },

    onCancelClick() {
      this.$emit('close');

      this.prevPassword = '';
      this.newPassword = '';
    },
  },
};
</script>
